/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Not_NowInputs */

const en_us2_engagement_not_now = /** @type {(inputs: Engagement_Not_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not now`)
};

const pt_br2_engagement_not_now = /** @type {(inputs: Engagement_Not_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora não`)
};

const es_419_engagement_not_now = /** @type {(inputs: Engagement_Not_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora no`)
};

const pt_pt2_engagement_not_now = /** @type {(inputs: Engagement_Not_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora não`)
};

const fr_fr2_engagement_not_now = /** @type {(inputs: Engagement_Not_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas maintenant`)
};

const de_de2_engagement_not_now = /** @type {(inputs: Engagement_Not_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht jetzt`)
};

const it_it2_engagement_not_now = /** @type {(inputs: Engagement_Not_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ora`)
};

/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Engagement_Not_NowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_not_now = /** @type {((inputs?: Engagement_Not_NowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Not_NowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_not_now(inputs)
	if (locale === "es-419") return es_419_engagement_not_now(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_not_now(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_not_now(inputs)
	if (locale === "de-DE") return de_de2_engagement_not_now(inputs)
	if (locale === "it-IT") return it_it2_engagement_not_now(inputs)
	return en_us2_engagement_not_now(inputs)
});
export { engagement_not_now as "engagement.not_now" }